import CheckoutOptions from "./CheckoutOptions";
import { RetailerConnect } from "./RetailerConnect";
import CheckoutOptionsV2 from "./CheckoutOptionsV2";
import { useGuestCheckoutEnabled } from "../useGuestCheckout";

const AccountForCheckout = ({ retailerId }: { retailerId?: number }) => {
  const { enabledGuestCheckout, experimentEnabled } =
    useGuestCheckoutEnabled(retailerId);

  if (!enabledGuestCheckout) {
    return <RetailerConnect />;
  }

  if (experimentEnabled) {
    return <CheckoutOptionsV2 />;
  }

  return <CheckoutOptions />;
};

export default AccountForCheckout;
